import { Onfido } from "onfido-sdk-ui";
import { Handle } from "onfido-sdk-ui/types/Onfido";
import { Applicant } from "../types";
import { ONFIDO_SDK_CONTAINER_ID } from "../onfido-sdk";
import { ThemeTemplate } from "../../theme/theme-template";

export const initOnFidoClient = async (
    applicant: Applicant,
    theme: ThemeTemplate,
    setOnFidoClient: (onFidoClient: Handle) => void,
    setHasClientError: (hasError: boolean) => void,
    completeJourney: (applicant?: Applicant) => void
) => {
    setOnFidoClient(
        Onfido.init({
            version: "14.45.2",
            token: applicant.sdkToken,
            smsNumberCountryCode: "IE",
            workflowRunId: applicant.workflowRunId,
            enterpriseFeatures: {
                logoCobrand: {
                    lightLogoSrc:
                        "https://digital.bankofireland.com/cdn/img/BOI_Logo_space.svg",
                    darkLogoSrc:
                        "https://digital.bankofireland.com/cdn/img/BOI_Logo_space.svg"
                }
            },
            customUI: {
                colorContentAlertInfo: theme.colors.brilliant,
                colorBackgroundAlertInfo: theme.colors.primary,
                colorBackgroundAlertInfoLinkHover: theme.colors.brilliant,
                colorBackgroundAlertInfoLinkActive: theme.colors.brilliant,
                colorContentAlertError: theme.colors.brilliant,
                colorBackgroundAlertError: theme.colors.alert,
                colorContentAlertErrorLinkHover: theme.colors.brilliant,
                colorContentAlertErrorLinkActive: theme.colors.brilliant,
                colorBorderSurfaceModal: theme.colors.brilliant,
                colorBackgroundSurfaceModal: theme.colors.brilliant,
                googleFonts: ["Open Sans"],
                fontFamilyTitle: "'Open Sans'",
                fontSizeTitle: "calc(30 * 1/16 * 0.993em)",
                fontFamilySubtitle: "'Open Sans'",
                fontFamilyBody: "'Open Sans'"
            },
            containerId: ONFIDO_SDK_CONTAINER_ID,
            onComplete: (data: { [key: string]: any }) => {
                const docPhotoKey = Object.keys(data).find(key =>
                    key.includes("document_photo")
                );
                docPhotoKey &&
                    completeJourney({
                        ...applicant,
                        selectedDocument: data[docPhotoKey]["output"][
                            "type"
                        ].replaceAll("_", "-")
                    });
            },
            onError: () => {
                setHasClientError(true);
            }
        })
    );
};
